"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RfisSubmittalsCommonCapabilities = void 0;
var RfisSubmittalsCommonCapabilities;
(function (RfisSubmittalsCommonCapabilities) {
    RfisSubmittalsCommonCapabilities["CanCreate"] = "can_create";
    RfisSubmittalsCommonCapabilities["CanLog"] = "can_log";
    RfisSubmittalsCommonCapabilities["CanManageConnectors"] = "can_manage_connectors";
    RfisSubmittalsCommonCapabilities["CanExport"] = "can_export";
    RfisSubmittalsCommonCapabilities["CanViewSyncError"] = "can_view_sync_error";
    RfisSubmittalsCommonCapabilities["CanViewSettings"] = "can_view_settings";
})(RfisSubmittalsCommonCapabilities = exports.RfisSubmittalsCommonCapabilities || (exports.RfisSubmittalsCommonCapabilities = {}));
//# sourceMappingURL=RfisSubmittalsCommonCapabilities.js.map